module.exports = __webpack_public_path__ + "media/countdown.19a77c38.flac";